export default class ScenarioState {
    constructor(scenarioId, state) {
        this._state = state;
        this._id = scenarioId;
    }

    get state() {
        return this._state;
    }

    set state(value) {
        this._state = value;
    }

    get id() {
        return this._id;
    }

    static STATE_AVAILABLE = "available";
    static STATE_STARTED = "started";
    static STATE_FINISHED = "finished";
}
